// src/api/studyPlanApi.js
//
// Student-facing Study Plan API calls, matching pyqApi.js's convention
// (askosAuthHeader() passed explicitly per call).
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

export const getStudyPlanToday = (slug) =>
  api.get(`/tenant/${slug}/askos/study-plan/today`, { headers: askosAuthHeader() }).then(r => r.data);

export const getStudyPlan = (slug) =>
  api.get(`/tenant/${slug}/askos/study-plan`, { headers: askosAuthHeader() }).then(r => r.data);

export const updateStudyPlanItem = (slug, itemId, payload) =>
  api.patch(`/tenant/${slug}/askos/study-plan/items/${itemId}`, payload, { headers: askosAuthHeader() }).then(r => r.data);

export const generateStudyPlan = (slug, targetExam) =>
  api.post(`/tenant/${slug}/askos/study-plan/generate`, { target_exam: targetExam || null }, { headers: askosAuthHeader() }).then(r => r.data);
